<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div class="card p-3 mb-3 shadow-sm">
      <div class="row no-gutters">
        <div class="col">
          <h3 class="text-left">SUMMARY FOR ALL VESSELS BY YEAR</h3>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-1 text-left m-0">
          <label for="month" class="col-form-label">FROM YEAR</label>
        </div>
        <div class="col-2 m-0">
          <select name="month" id="month" class="form-control form-control-sm" v-model="fromYear" @change="changeToYearValue">
            <option :value="year" v-for="year in years">{{year}}</option>
          </select>
        </div>
        <div class="col-1 text-left m-0">
          <label for="month" class="col-form-label">TO YEAR</label>
        </div>
        <div class="col-2 m-0">
          <select name="month" id="month" class="form-control form-control-sm" v-model="toYear">
            <option :value="year" v-for="year in years" :disabled="year < fromYear">{{year}}</option>
          </select>
        </div>

        <div class="col-2 m-0">
          <button id="committeeReport" class="mr-2 e-btn e-btn-blue-gray force-white-all"
                  :disabled="summaryLoading === true"
                  :class="summaryLoading === true ? 'e-btn-blue-gray-disabled' : ''"
                  @click="getSummaryFromYearRange"
          >
            Search
          </button>
        </div>



      </div>
      <div class="p-0 m-0">
        <table class="summary">
          <thead>
          <tr class="text-center">
            <th class="lead bg-ffd966" style="width: 135px;">YEARS</th>
            <th style="width: 135px;" v-for="(year, index) in yearsRange" :key="index">
              {{ year }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="summaryLoading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>
          <template v-else>
            <tr class="text-center">
              <td></td>
              <template v-for="data in vesselAccidentIncidentWorkingEnvironmentsSummary">
                <td class="number">
                  {{ data.count }}
                </td>
              </template>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card p-3 shadow-sm">
      <div class="col-lg-12 ">
        <div class="row no-gutters">
          <div class="col pb-2">
            <nav aria-label="...">
              <ul class="pagination text-smallest mb-0 pb-0">
                <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                  <button class="page-link" @click="setData(1)">First</button>
                </li>

                <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                  <button class="page-link" @click="setData(page)">{{ page }}</button>
                </li>

                <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                  <button class="page-link" @click="setData(pagination.lastPage)">Last</button>
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-md-auto">
            <label class="col-form-label pr-2 font-weight-bold">Filter By: </label>
          </div>
          <div class="col-md-auto px-1">
            <select class="form-control form-control-sm text-uppercase" id="fleetList" v-model="params.fleet_id">
              <option :value="null">-- ALL FLEET --</option>
              <template v-for="fleet in fleetKeys">
                <option :value="fleet.id" v-if="fleet.name !== 'N/A' && fleet.code !== 'N/A'">
                  {{fleet.name ? fleet.name.toUpperCase() : ''}}
                </option>
              </template>
            </select>
          </div>

          <div class="col-3 pb-2">
            <input type="text" name="vesselSearch" class="form-control form-control-sm" v-model="params.search" placeholder="Search Vessel">
          </div>
        </div>
      </div>
      <div class="row col-12 p-0 m-0">
        <table class="table text-center table-sm small e-tbl">
          <thead class="bg-white">
          <tr>
            <th class="align-middle" style="width: 1em" scope="col">#</th>
            <th class="text-uppercase align-middle" scope="col">VESSEL NAME</th>
            <th class="text-uppercase align-middle" scope="col">FLEET</th>
            <th class="text-uppercase align-middle" scope="col">MANAGEMENT BRANCH OFFICE</th>

            <template v-if="$route.params.feature === 'medical_type'">
              <template v-for="key in medicalTypeKeys">
                <th class="text-uppercase align-middle" scope="col">{{ key.name.toUpperCase() }}</th>
              </template>
            </template>
            <template v-if="$route.params.feature === 'occupational_accidents'">
              <template v-for="key in medicalSeverityKeys">
                <th class="text-uppercase align-middle" scope="col">{{ key.name.toUpperCase() }}</th>
              </template>
            </template>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>

          <template v-else>
            <template v-if="vesselAccidentIncidentWorkingEnvironments.length === 0">
              <tr>
                <td colspan="100%" class="align-middle text-center">
                  <p class="h5 py-1">NO RESULTS FOUND</p>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(data, index) in vesselAccidentIncidentWorkingEnvironments" class="vessel-accident-incident-count no-select">
                <td class="align-middle">{{ index + pagination.from }}</td>
                <td class="align-middle text-uppercase">{{ data.name }}</td>
                <td class="align-middle text-uppercase">{{ data.fleet?.name }}</td>
                <td class="align-middle text-uppercase">{{ data.management_office?.name }}</td>

                <template v-for="workingEnvironmentData in data.working_environments">
                  <td class="align-middle text-uppercase number">
                    <template v-if="workingEnvironmentData.personnel.length === 0">{{ workingEnvironmentData.personnel.length }}</template>
                    <a v-else href="#" @click="getDataForRecord(data, data.working_environments_feature, workingEnvironmentData)">{{ workingEnvironmentData.personnel.length }}</a>
                  </td>
                </template>
              </tr>
            </template>
          </template>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal fade" id="workingEnvironmentListModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-uppercase" id="exampleModalLabel">{{ modalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table class="small e-tbl table-modal">
              <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">

              <tr>
                <th class="align-middle text-center" rowspan="2" style="width: 1em" scope="col">#</th>
                <th class="align-middle text-center" scope="col" colspan="2">PERSONNEL</th>
                <th class="align-middle text-center" scope="col" colspan="3">ACCIDENT INCIDENT</th>
                <th class="align-middle text-center" rowspan="2" scope="col">ACTION</th>
              </tr>
              <tr>
                <th class="align-middle text-center" scope="col">NAME</th>
                <th class="align-middle text-center" scope="col">RANK</th>
                <th class="align-middle text-center" rowspan="2" scope="col">REPORT NUMBER</th>
                <th class="align-middle text-center" rowspan="2" scope="col">REPORT TITLE</th>
                <th class="align-middle text-center" rowspan="2" scope="col">EVENT DATE</th>
              </tr>

              </thead>
              <tbody>
              <template v-if="modalLoading">
                <tr>
                  <td colspan="100%">
                    <app-loading></app-loading>
                  </td>
                </tr>
              </template>
              <template v-else>
                <template v-for="(data, index) in modalWorkingEnvironmentData">
                  <template v-for="(ai, ai_index) in data.accident_incidents">
                    <tr>
                      <template v-if="ai_index === 0">
                        <td :rowspan="data.accident_incidents.length" class="align-middle text-center text-uppercase">{{ index + 1 }}</td>
                        <td :rowspan="data.accident_incidents.length" class="align-middle text-center text-uppercase">{{ data?.cms_crew_full_name }}</td>
                        <td :rowspan="data.accident_incidents.length" class="align-middle text-center text-uppercase">{{data?.rank_alias1 }}</td>
                      </template>

                      <td class="align-middle text-center text-uppercase">{{ ai.report_number }}</td>
                      <td class="align-middle text-center text-uppercase">{{ ai.title }}</td>
                      <td class="align-middle text-center text-uppercase">{{ ai.event_date }}</td>
                      <td class="align-middle text-center">
                        <button class="e-btn e-btn-blue e-btn-sm e-text-white my-1" @click="showReport(ai.id)">
                          <font-awesome-icon icon="eye"  />
                          View
                        </button>
                      </td>
                    </tr>
                  </template>
                </template>

              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {permissionMixin} from "@/mixins/permissionMixins";
import {mapActions, mapGetters} from "vuex";
import AppLoading from "@/components/elements/AppLoading.vue";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import {VesselService} from "@/services/VesselService";
import Table from "@/components/layouts/Table.vue";

export default {
  name: 'WorkingEnvironments',
  mixins: [permissionMixin, PaginationMixin],
  data() {
    const toYear = new Date().getFullYear();
    const fromYear = toYear - 10;
    return {
      loading: true,
      summaryLoading : true,
      params : {
        feature : this.$route.params.feature,
        fleet_id: null,
      },
      yearsRange : [],
      fromYear,
      toYear,
      modalLoading : false,
      modalTitle : '',
      modalWorkingEnvironmentData : [],
      eventOneColorCode : {
        a : { // 1
          color: '#0000ff',
          color_code: '0000ff'
        },
        b: { // 2
          color: '#0000ff',
          color_code: '0000ff'
        },
        c: { // 3
          color: '#ff0000',
          color_code: 'ff0000'
        },
        d: { // 4
          color: '#ffbf00',
          color_code: 'ffbf00'
        },
        e: { // 5
          color: '#c75912',
          color_code: 'c75912'
        },
        f: { // 6
          color: '#c75912',
          color_code: 'c75912'
        },
        g: { // 7
          color: '#7030a0',
          color_code: '7030a0'
        },
        h: { // 8
          color: '#7030a0',
          color_code: '7030a0'
        },
        i: { // 9
          color: '#548235',
          color_code: '548235'
        },
        j: { // 10
          color: '#ff0066',
          color_code: 'ff0066'
        },
        k: { // 11
          color: '#2f5496',
          color_code: '2f5496'
        },
        l: { // 12
          color: '#2f5496',
          color_code: '2f5496'
        },
        m: { // 13
          color: '#a6a6a6',
          color_code: 'a6a6a6'
        }
      },
      downloadExcelResult: false
    }
  },
  components: {
    Table,
    AppLoading,
  },
  methods: {
    ...mapActions([
      'getVesselsWorkingEnvironment',
      'getFleetListKeys',
      'getMedicalTypeKeys',
      'getMedicalSeverityKeys',
    ]),
    getYearsRange(startYear, endYear) {
      const years = [];
      for (let year = startYear; year <= endYear; year++) {
        years.push(year);
      }
      return years;
    },
    changeToYearValue() {
      if (this.fromYear > this.toYear) {
        this.toYear = this.fromYear;
      }
    },
    async downloadResult() {
      let params = Object.assign({}, this.params);
      params.excel = 1;

      const SwalTitleMapper = {
        'number_of_report': 'NUMBER OF REPORT',
        'number_of_delay': 'NUMBER OF DELAY',
        'delay_hours': 'DELAY HOURS',
      }


      swal.fire({
        'title': `DOWNLOADING ${SwalTitleMapper[this.$route.params.feature]}<br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()

      const downloadResponse = await VesselService.downloadVesselAccidentIncidentYearlyCount(params);
      swal.close()
      let url = window.URL.createObjectURL(new Blob([downloadResponse.data], {type: 'application/vnd.ms-excel'}))
      let filename = `${this.$route.params.feature}_${Date.now()}.xlsx`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    async setData(page = 1) {
      this.loading = true;
      this.params.page = page;
      await this.getVesselsWorkingEnvironment(this.params)
      this.loading = false;
    },
    async getDataForRecord(vesselData, workingEnvironmentFeature, featureData) {
      this.modalLoading = true;
      $('#workingEnvironmentListModal').modal('show');
      this.modalTitle = `${vesselData.name} (${featureData.name})`;
      this.modalWorkingEnvironmentData = featureData.personnel;
      this.modalLoading = false;
    },
    async showReport (reportId) {
      const route= this.$router.resolve(
        {
          name: 'Loss',
          params: {
            id: reportId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    async requestKeys() {
      if (this.fleetKeys === null) {
        const fleetKeys = await this.getFleetListKeys();
        localStorage.setItem('fleetKeys', JSON.stringify(fleetKeys));
      }

      if (this.medicalTypeKeys === null) {
        const medicalTypeKeys = await this.getMedicalTypeKeys();
        localStorage.setItem('medicalTypeKeys', JSON.stringify(medicalTypeKeys));
      }

      if (this.medicalSeverityKeys === null) {
        const medicalSeverityKeys = await this.getMedicalSeverityKeys();
        localStorage.setItem('medicalSeverityKeys', JSON.stringify(medicalSeverityKeys));
      }
    },
    async getSummaryFromYearRange() {
      this.yearsRange = this.getYearsRange(this.fromYear, this.toYear);

      this.summaryLoading = true;
      const params = {
        feature : this.$route.params.feature,
        summary : true,
        from    : this.fromYear,
        to      : this.toYear
      };

      await this.getVesselsWorkingEnvironment(params);
      this.summaryLoading = false;
    }
  },
  async created() {
    this.yearsRange = this.getYearsRange(this.fromYear, this.toYear);
  },
  async mounted() {
    await this.requestKeys();

    this.loading = true;
    this.setVesselsData = _.debounce(this.setData, 750)
    await this.setData();
    await this.getSummaryFromYearRange();

  },
  computed: {
    ...mapGetters([
      'vesselAccidentIncidentWorkingEnvironments',
      'vesselAccidentIncidentWorkingEnvironmentsSummary',
      'pagination',
      'fleetKeys',
      'medicalTypeKeys',
      'medicalSeverityKeys',
    ]),
    fleetKeys() {
      return JSON.parse(localStorage.getItem('fleetKeys'));
    },
    medicalTypeKeys() {
      return JSON.parse(localStorage.getItem('medicalTypeKeys'));
    },
    medicalSeverityKeys() {
      return JSON.parse(localStorage.getItem('medicalSeverityKeys'));
    },
    years() {
      const currentYear = new Date().getFullYear();
      const tenYearsFromNow = currentYear - 10;
      return Array.from({length: currentYear - tenYearsFromNow + 1}, (_, index) => tenYearsFromNow + index);
    }
  },
  watch: {
    'params.search'() {
      this.setVesselsData()
    },
    'params.fleet_id'() {
      this.setData()
    },
  },
}
</script>

<style scoped>
tr th, tr td.number, tr td.number a {
  font-size: 1rem;
  font-weight: bold;
}

.modal-body .e-tbl thead tr th {
  border: 1px solid #b1b1b1;
}

.years-column {
  width: 135px !important;
  max-width: 135px !important;
}

.fixed-width-table {
  table-layout: fixed;
  width: 100%;
}

table.summary th,  table.summary td{
  border-collapse: separate;
  background-color: #fff;
  border: 1px solid #ddd;
  border-spacing: 0;
}

table.summary tr th, table.summary tr td.number {
  font-size: 1rem;
  font-weight: bold;
}
</style>


